export enum USER_PROFILE_PATH {
  ID_926931d2 = './Images/profile1.png',
  ID_c58e261b = './Images/profile2.png',
  ID_65bd3353 = './Images/profile3.png',
}

export const USER: string = 'USER';
